import React from 'react'
import { useDraftContext } from '../../../../Context/DraftContext/DraftContext'
import {
  BadgeContainer,
  BadgeText,
  DotSeparator,
  LogoContainer,
  OnTheClockCard,
  OnTheClockContent,
  OnTheClockWrapper,
  PickInfo,
  PickNumber,
  TeamName,
  TextInfo,
} from './styles'
import { Img } from '../../../../Components/Image/Img'
import { useAnimatedPick } from '../../../../Hooks/draft/useAnimatedPick'
import {
  getFullTeamName,
  getTeamColor,
  getTeamIc,
} from '../../../../Utils/Teams/teamHelpers'

export const OnTheClock: React.FC = () => {
  const { nextTeamToPick } = useDraftContext()
  const { currentPick, animationState } = useAnimatedPick(nextTeamToPick)

  if (!currentPick && animationState !== 'exiting') return null

  return (
    <OnTheClockWrapper>
      <OnTheClockCard
        animationState={animationState}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-label={`On the clock: ${
          currentPick ? getFullTeamName(currentPick.teamId) : 'Transitioning'
        }, Pick ${currentPick ? currentPick.overallPick : '-'}`}
      >
        {currentPick && (
          <OnTheClockContent>
            <LogoContainer teamColor={getTeamColor(currentPick.teamId)}>
              <Img src={getTeamIc(currentPick.teamId)} alt={currentPick.teamId} />
            </LogoContainer>
            <TextInfo>
              <TeamName>{getFullTeamName(currentPick.teamId)}</TeamName>
              <PickInfo>
                <PickNumber>Pick #{currentPick.overallPick}</PickNumber>
                <DotSeparator>•</DotSeparator>
                <PickNumber>
                  Rd {currentPick.round}, Pick {currentPick.roundPick}
                </PickNumber>
              </PickInfo>
            </TextInfo>
            <BadgeContainer>
              <BadgeText>On The Clock</BadgeText>
            </BadgeContainer>
          </OnTheClockContent>
        )}
      </OnTheClockCard>
    </OnTheClockWrapper>
  )
}
